module.exports = __webpack_public_path__ + "media/components/assets/images/tamgeulAllkill/image2-dc01cafe5b0548de585034eda714073b.png";